import React, { useEffect } from 'react';
import { Box, Typography, Card, CardContent, Avatar, Button } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/pagination';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const testimonials = [
  {
    name: 'Bhavana Mannam',
    feedback: '✨ Today’s session helped me revise all concepts. Grateful to Spark AI!',
    avatar: 'https://i.pravatar.cc/150?img=30',
    rating: 5,
  },
  {
    name: 'Intern Learner',
    feedback: '🚀 Finished assignments. Thank you @Mr.Sumanth 🤍',
    avatar: 'https://i.pravatar.cc/150?img=35',
    rating: 4,
  },
  {
    name: 'Grateful Learner',
    feedback: '💡 Gained hands-on experience. Spark AI = confidence boost!',
    avatar: 'https://i.pravatar.cc/150?img=38',
    rating: 5,
  },
  {
    name: 'MERN Intern',
    feedback: '📚 Clear theory, helpful real-time examples. Powerful learning!',
    avatar: 'https://i.pravatar.cc/150?img=42',
    rating: 5,
  },
];

function TestimonialsSection() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Box
      id="testimonials"
      sx={{
        background: 'linear-gradient(to right, #0c1e3c, #112244)',
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4, md: 8 },
        textAlign: 'center',
        color: '#ffffff',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          color: '#ffcb05',
          mb: 4,
          fontFamily: 'Poppins, sans-serif',
        }}
        data-aos="fade-up"
      >
        🌟 What Our Students Say
      </Typography>

      <Swiper
        spaceBetween={30}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          1024: { slidesPerView: 2 },
        }}
        modules={[Pagination, Autoplay]}
        style={{ paddingBottom: '40px' }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Card
              elevation={4}
              data-aos="zoom-in"
              sx={{
                maxWidth: 500,
                mx: 'auto',
                p: 3,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #1a2a4f, #0c1e3c)',
                color: '#ffffff',
                height: '100%',
                boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
              }}
            >
              <CardContent>
                <Avatar
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  sx={{
                    width: 64,
                    height: 64,
                    mx: 'auto',
                    mb: 2,
                    border: '3px solid #ffcb05',
                    animation: 'bounce 2s infinite',
                  }}
                />
                {/* ⭐ Star Rating */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                  {[...Array(5)].map((_, i) =>
                    i < testimonial.rating ? (
                      <StarIcon key={i} sx={{ color: '#ffcb05', fontSize: '1.2rem' }} />
                    ) : (
                      <StarBorderIcon key={i} sx={{ color: '#ffcb05', fontSize: '1.2rem' }} />
                    )
                  )}
                </Box>

                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 'bold', mb: 1, color: '#ffcb05' }}
                >
                  {testimonial.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontStyle: 'italic', color: '#ddd' }}
                >
                  "{testimonial.feedback}"
                </Typography>
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      <Box sx={{ mt: 5 }}>
        <Button
          variant="contained"
          data-aos="fade-up"
          sx={{
            background: 'linear-gradient(to right, #ffcb05, #ffe873)',
            color: '#0c1e3c',
            fontWeight: 'bold',
            textTransform: 'none',
            borderRadius: '30px',
            px: 4,
            py: 1.5,
            boxShadow: '0px 4px 12px rgba(255, 203, 5, 0.4)',
            '&:hover': {
              backgroundColor: '#f7be03',
            },
          }}
          onClick={() =>
            window.open('https://www.linkedin.com/company/spark-ai-edu-tech/', '_blank')
          }
        >
          🔗 See More on LinkedIn
        </Button>
      </Box>

      {/* Avatar bounce animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-8px);
            }
            60% {
              transform: translateY(-4px);
            }
          }
        `}
      </style>
    </Box>
  );
}

export default TestimonialsSection;
